interface StatsCardSkeletonProps {
    count?: number
}

export const StatsCardSkeleton = ({ count = 1 }: StatsCardSkeletonProps) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow-bizu border border-gray-100 sm:px-6 sm:pt-6 animate-pulse"
                >
                    <div className="flex items-start">
                        <div className="absolute rounded-md p-3 bg-gray-200 w-12 h-12"></div>
                        <div className="ml-16 flex-1">
                            <div className="h-4 bg-gray-200 rounded w-2/3 mb-3"></div>
                            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

interface ActivityFeedSkeletonProps {
    count?: number
}

export const ActivityFeedSkeleton = ({ count = 3 }: ActivityFeedSkeletonProps) => {
    return (
        <div className="bg-white rounded-lg shadow-bizu p-6">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
            <div className="space-y-4">
                {Array.from({ length: count }).map((_, index) => (
                    <div key={index} className="flex items-start gap-3 animate-pulse">
                        <div className="w-10 h-10 bg-gray-200 rounded-full flex-shrink-0"></div>
                        <div className="flex-1">
                            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

interface RecentItemsSkeletonProps {
    count?: number
}

export const RecentItemsSkeleton = ({ count = 3 }: RecentItemsSkeletonProps) => {
    return (
        <div className="bg-white rounded-lg shadow-bizu p-6">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
            <div className="space-y-3">
                {Array.from({ length: count }).map((_, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-4 animate-pulse">
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 bg-gray-200 rounded-lg flex-shrink-0"></div>
                            <div className="flex-1">
                                <div className="h-3 bg-gray-200 rounded w-1/4 mb-2"></div>
                                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                                <div className="h-3 bg-gray-200 rounded w-full"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StatsCardSkeleton
